import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../feature/authSlice";
import { useNavigate } from "react-router-dom";
import "./css/LoginPage.css";

const AdminUserLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [authError, setAuthError] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.auth);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setShowLoader(true);
      setTimeout(() => navigate("/admin/home/banner"), 5000);
    }
  }, [navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowLoader(true);
    setAuthError("");

    dispatch(loginUser({ email, password }))
      .unwrap()
      .then(() => {
        setTimeout(() => navigate("/admin/home/banner"), 5000);
      })
      .catch(() => {
        setShowLoader(false);
        setAuthError("Login failed. Please try again.");
      });
  };

  return (
    <div className="admin-login-container">
      {showLoader ? (
        <p>Redirecting...</p>
      ) : (
        <form
          className="admin-login-form_container"
          onSubmit={handleSubmit}
        >
          <div className="admin-login-title_container">
            <p className="admin-login-title">Login to your Account</p>
          </div>

          {authError && <p style={{ color: "red" }}>{authError}</p>}

          <div className="admin-login-input_container">
            <label className="admin-login-input_label">Email</label>
            <input
              type="email"
              className="admin-login-input_field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="admin-login-input_container">
            <label className="admin-login-input_label">Password</label>
            <input
              type="password"
              className="admin-login-input_field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="admin-login-sign-in_btn"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      )}
    </div>
  );
};

export default AdminUserLogin;
